export enum ListingDocumentType {
  registration = 'registration',
}
